export default __webpack_public_path__ + "static/OYOY-1920x390-30fps-d0b6205472183e889e37e43a41393122.mp4";